import React from 'react';
import { View, Text, Linking, Pressable, FlexAlignType } from 'react-native';
import { DynamicLinkButtonProps } from '../../Types/ControlTypes';
import { CommonStyleSheet } from '../../Styles/Shared/CommonStyles';
import Colors from '../../Styles/Shared/Colors';

const DynamicLinkButton = (
  props: DynamicLinkButtonProps,
): React.ReactElement => {
  const goToRef = () => {
    const href = props.config?.href;
    if (href) Linking.openURL(href);
  };

  function getAlign(): FlexAlignType {
    let align: FlexAlignType = 'flex-start';

    if (props.config && props.config.align) {
      switch (props.config.align) {
        case 'left':
          align = 'flex-start';
          break;
        case 'center':
          align = 'center';
          break;
        case 'right':
          align = 'flex-end';
          break;
      }
    }

    return align;
  }

  return (
    <View style={{ display: props.visible === false ? 'none' : 'flex' }}>
      <Pressable
        style={({ pressed }) => [
          CommonStyleSheet.greenButton,
          {
            alignSelf: getAlign(),
          },
          props.disabled && {
            backgroundColor: Colors.gray,
          },
          pressed && {
            opacity: 0.8,
          },
        ]}
        disabled={props.disabled}
        onPress={() => goToRef()}>
        <Text style={CommonStyleSheet.greenButtonText}>
          {props.config?.text ?? 'Go'}
        </Text>
      </Pressable>
    </View>
  );
};

export default DynamicLinkButton;
